import { ListDebts } from '~/features/Debt/ListDebts'
import { PageContainer } from '~/shared/ui/PageContainer'
import { Title } from './styled'
import { useRefreshPage } from './useRefreshPage'

export function ListDebtsPage() {
  const { refreshPage } = useRefreshPage()
  return (
    <PageContainer
      canBack
      backTitle='Задолженности'
      title='Задолженности'
      preventScrollReset
      onRefreshPage={refreshPage}
    >
      <Title>Текущие задолженности</Title>
      <ListDebts />
    </PageContainer>
  )
}
